import React from 'react';
import dayjs from 'dayjs';
import { FaCalendarAlt, FaIdCard, FaBuilding, FaPhone, FaEnvelope, FaClock, FaMedal, FaUser, FaInfoCircle, FaSwimmer, FaVenusMars, FaCreditCard, FaBan, FaUsers, FaExchangeAlt } from 'react-icons/fa';

const PremiumAppointmentDetailView = ({ appointmentDetail }) => {
    if (!appointmentDetail) return null;

    const isClub = appointmentDetail.reservationType === 'Club' || appointmentDetail.blockSource === 'Club';
    const isBlocked = appointmentDetail.reservationType === 'Blocked' || ['Maintenance', 'PublicEducation', 'PublicEducationCourse'].includes(appointmentDetail.blockSource);
    const isCapacity = appointmentDetail.reservationType === 'CapacitySummary';
    const isIndividual = !isClub && !isBlocked && !isCapacity;

    const facilityStr = `${appointmentDetail.sportTypeName || ''} ${appointmentDetail.facilityName || ''} ${appointmentDetail.regionName || ''}`.toLowerCase();
    const isPool = facilityStr.includes('havuz') || facilityStr.includes('yüzme');

    const renderRow = (label, value, icon, isHighlight = false) => {
        if (!value || value === '-') return null;
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '14px 16px',
                borderBottom: '1px solid #f1f5f9',
                background: isHighlight ? '#f8fafc' : '#ffffff',
                transition: 'background 0.2s',
            }}
                onMouseOver={(e) => e.currentTarget.style.background = '#f8fafc'}
                onMouseOut={(e) => e.currentTarget.style.background = isHighlight ? '#f8fafc' : '#ffffff'}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#64748b', fontSize: '0.9rem', fontWeight: 500 }}>
                    <span style={{ color: '#94a3b8' }}>{icon}</span>
                    <span>{label}</span>
                </div>
                <div style={{ color: '#0f172a', fontSize: '0.95rem', fontWeight: 600, textAlign: 'right', wordBreak: 'break-word', maxWidth: '60%' }}>
                    {value}
                </div>
            </div>
        );
    };

    const TopCard = () => {
        if (isClub) {
            // Multi-club view
            const clubs = appointmentDetail.clubSlotDetails;
            if (clubs && clubs.length > 0) {
                return (
                    <div style={{ marginBottom: '20px' }}>
                        <div style={{
                            padding: '14px 16px',
                            background: 'linear-gradient(135deg, #dcfce7, #bbf7d0)',
                            borderRadius: '12px 12px 0 0',
                            border: '1px solid #86efac',
                            borderBottom: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px'
                        }}>
                            <div style={{
                                width: '40px', height: '40px', borderRadius: '10px',
                                background: '#22c55e', color: 'white',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: '1.2rem', boxShadow: '0 2px 4px rgba(34, 197, 94, 0.3)'
                            }}>
                                <FaMedal />
                            </div>
                            <div>
                                <div style={{ fontWeight: 700, fontSize: '1.05rem', color: '#166534' }}>
                                    Bu Saatteki Kulüpler ({clubs.length})
                                </div>
                                <div style={{ fontSize: '0.8rem', color: '#15803d', fontWeight: 500 }}>
                                    Kulüp Saat Atamaları
                                </div>
                            </div>
                        </div>
                        <div style={{
                            border: '1px solid #86efac',
                            borderRadius: '0 0 12px 12px',
                            overflow: 'hidden'
                        }}>
                            {clubs.map((club, idx) => {
                                const paid = club.isPaid || club.status === 'Confirmed';
                                return (
                                    <div key={club.clubApplicationId || idx} style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '14px 16px',
                                        borderBottom: idx < clubs.length - 1 ? '1px solid #e2f5e9' : 'none',
                                        background: idx % 2 === 0 ? '#fff' : '#f7fdf9',
                                        transition: 'background 0.2s'
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <div style={{
                                                width: '36px', height: '36px', borderRadius: '50%',
                                                background: paid ? 'linear-gradient(135deg, #22c55e, #16a34a)' : 'linear-gradient(135deg, #f59e0b, #d97706)',
                                                color: 'white',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                fontSize: '0.85rem', fontWeight: 700,
                                                boxShadow: `0 2px 4px ${paid ? 'rgba(34,197,94,0.25)' : 'rgba(245,158,11,0.25)'}`
                                            }}>
                                                {idx + 1}
                                            </div>
                                            <div>
                                                <div style={{ fontWeight: 600, fontSize: '0.9rem', color: '#1e293b' }}>
                                                    {club.clubName}
                                                    {(!club.clubName.includes('Kulüb')) ? ' Kulübü' : ''}
                                                </div>
                                                <div style={{ fontSize: '0.78rem', color: '#64748b', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    {club.taxNumber && <span>VKN: {club.taxNumber}</span>}
                                                    {club.personCount > 0 && (
                                                        <span style={{
                                                            background: '#e0f2fe',
                                                            color: '#0369a1',
                                                            padding: '1px 6px',
                                                            borderRadius: '4px',
                                                            fontSize: '0.72rem',
                                                            fontWeight: 600
                                                        }}>
                                                            {isPool ? <><FaSwimmer style={{ marginRight: '3px', fontSize: '0.7rem' }} />{club.personCount} Kulvar</> : <><FaUsers style={{ marginRight: '3px', fontSize: '0.7rem' }} />{club.personCount} Kişi</>}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <span style={{
                                            padding: '5px 12px',
                                            borderRadius: '16px',
                                            fontSize: '0.75rem',
                                            fontWeight: 600,
                                            background: paid ? '#dcfce7' : '#fef3c7',
                                            color: paid ? '#166534' : '#92400e',
                                            boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {paid ? '✓ Ödendi' : '⏳ Ödenmedi'}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            }

            // Fallback: single club (no clubSlotDetails)
            return (
                <div style={{ padding: '16px', background: 'linear-gradient(135deg, #dcfce7, #bbf7d0)', borderRadius: '12px', border: '1px solid #86efac', display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                    <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: '#22c55e', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', boxShadow: '0 4px 6px -1px rgba(34, 197, 94, 0.3)' }}>
                        <FaMedal />
                    </div>
                    <div>
                        <div style={{ fontWeight: 700, fontSize: '1.15rem', color: '#166534', letterSpacing: '-0.01em', marginBottom: '4px' }}>
                            {appointmentDetail.isTransferred ? (
                                <><FaExchangeAlt style={{ marginRight: '8px', fontSize: '0.9em' }} /> Aktarılan Seans</>
                            ) : (
                                <>{appointmentDetail.firstName} {appointmentDetail.lastName} {(!appointmentDetail.lastName?.includes('Kulüb') && !appointmentDetail.firstName?.includes('Kulüb')) ? 'Kulübü' : ''}</>
                            )}
                        </div>
                        <div style={{ fontSize: '0.85rem', color: '#15803d', fontWeight: 500 }}>
                            {appointmentDetail.isTransferred ? (
                                <>Orijinal Tarih: {dayjs(appointmentDetail.originalSessionDate).format('DD MMMM YYYY')} - {appointmentDetail.firstName} {appointmentDetail.lastName}</>
                            ) : 'Kulüp Saat Ataması'}
                        </div>
                    </div>
                </div>
            );
        } else if (isBlocked) {
            return (
                <div style={{ padding: '16px', background: 'linear-gradient(135deg, #fef3c7, #fde68a)', borderRadius: '12px', border: '1px solid #fcd34d', display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                    <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: '#f59e0b', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', boxShadow: '0 4px 6px -1px rgba(245, 158, 11, 0.3)' }}>
                        <FaBan />
                    </div>
                    <div>
                        <div style={{ fontWeight: 700, fontSize: '1.15rem', color: '#92400e', letterSpacing: '-0.01em', marginBottom: '4px' }}>
                            Saat Kapatılmış
                        </div>
                        <div style={{ fontSize: '0.85rem', color: '#b45309', fontWeight: 500 }}>
                            {appointmentDetail.blockSource === 'PublicEducation' ? 'Halk Eğitim' :
                                appointmentDetail.blockSource === 'PublicEducationCourse' ? 'Halk Eğitim Kursu' :
                                    appointmentDetail.blockSource === 'Maintenance' ? 'Bakım / Manuel Kapatma' : 'Takvimden Kapatma'}
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div style={{ padding: '16px', background: 'linear-gradient(135deg, #eff6ff, #dbeafe)', borderRadius: '12px', border: '1px solid #bfdbfe', display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                    <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: '#3b82f6', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', boxShadow: '0 4px 6px -1px rgba(59, 130, 246, 0.3)' }}>
                        <FaUser />
                    </div>
                    <div>
                        <div style={{ fontWeight: 700, fontSize: '1.15rem', color: '#1e3a8a', letterSpacing: '-0.01em', marginBottom: '4px' }}>
                            {appointmentDetail.firstName} {appointmentDetail.lastName}
                        </div>
                        <div style={{ fontSize: '0.85rem', color: '#1d4ed8', fontWeight: 500 }}>Bireysel Randevu</div>
                    </div>
                </div>
            );
        }
    };

    return (
        <div style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif" }}>
            <TopCard />

            <div style={{ background: '#ffffff', borderRadius: '12px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                {isClub && !appointmentDetail.clubSlotDetails?.length && renderRow('Kulüp Adı', `${appointmentDetail.firstName || ''} ${appointmentDetail.lastName || ''}`.trim(), <FaBuilding />)}
                {isIndividual && renderRow('Ad Soyad', `${appointmentDetail.firstName || ''} ${appointmentDetail.lastName || ''}`.trim(), <FaUser />)}
                {isBlocked && renderRow('Sebep / Kişi', appointmentDetail.sportTypeName || appointmentDetail.lastName || 'Belirtilmemiş', <FaInfoCircle />)}

                {!isClub && renderRow('Vergi No', appointmentDetail.taxNumber, <FaIdCard />)}
                {renderRow('TC Kimlik', appointmentDetail.identityNumber, <FaIdCard />)}
                {renderRow('Cinsiyet', appointmentDetail.userGender === 'Male' ? 'Erkek' : appointmentDetail.userGender === 'Female' ? 'Kadın' : appointmentDetail.userGender === 'Mixed' ? 'Karma' : appointmentDetail.userGender, <FaVenusMars />)}
                {renderRow('Telefon', appointmentDetail.phone, <FaPhone />)}
                {renderRow('E-posta', appointmentDetail.email, <FaEnvelope />)}

                {renderRow('Tesis', appointmentDetail.regionName ? `${appointmentDetail.regionName} / ${appointmentDetail.facilityName}` : appointmentDetail.facilityName, <FaBuilding />, true)}
                {renderRow('Tesis Türü', appointmentDetail.sportTypeName, <FaInfoCircle />)}
                {renderRow('Tarih', appointmentDetail.appointmentDate ? new Date(appointmentDetail.appointmentDate).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' }) : null, <FaCalendarAlt />)}
                {renderRow('Saat', appointmentDetail.startTime ? `${appointmentDetail.startTime} - ${appointmentDetail.endTime}` : null, <FaClock />)}
                {!isClub && appointmentDetail.personCount > 0 && renderRow(
                    isClub ? (isPool ? 'Kulvar Sayısı' : 'Kişi Sayısı') : 'Kişi Sayısı',
                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'flex-end' }}>
                        {isPool ? <FaSwimmer style={{ color: '#0ea5e9' }} /> : <FaUsers style={{ color: '#0ea5e9' }} />}
                        {appointmentDetail.personCount} {isClub ? (isPool ? 'Kulvar' : 'Kişi') : 'Kişi'}
                    </span>,
                    <FaUsers />
                )}
            </div>

            {/* Per-club payment status is now shown in the TopCard for clubs */}
            {(!isBlocked && !isClub && (appointmentDetail.paymentStatus || appointmentDetail.paymentAmount > 0 || appointmentDetail.status === 'Confirmed')) && (
                <div style={{ marginTop: '20px', padding: '16px', borderRadius: '12px', border: '1px solid #e2e8f0', background: '#f8fafc', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: '#e2e8f0', color: '#64748b', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem' }}>
                            <FaCreditCard />
                        </div>
                        <div>
                            <div style={{ fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '0.05em', marginBottom: '2px' }}>Ödeme Durumu</div>
                            <div style={{ fontSize: '1.05rem', fontWeight: 700, color: '#334155' }}>
                                {appointmentDetail.paymentAmount ? `${Number(appointmentDetail.paymentAmount).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} TL` : 'Ücretsiz / Abonelik'}
                            </div>
                        </div>
                    </div>
                    <div>
                        <span style={{
                            padding: '6px 14px', borderRadius: '20px', fontSize: '0.8rem', fontWeight: 600,
                            background: (['AUTH', 'SALE', 'APPROVED'].includes(appointmentDetail.paymentStatus?.toUpperCase()) || appointmentDetail.status === 'Confirmed') ? '#dcfce7' : appointmentDetail.paymentStatus === 'DECLINED' ? '#fee2e2' : '#fef3c7',
                            color: (['AUTH', 'SALE', 'APPROVED'].includes(appointmentDetail.paymentStatus?.toUpperCase()) || appointmentDetail.status === 'Confirmed') ? '#166534' : appointmentDetail.paymentStatus === 'DECLINED' ? '#991b1b' : '#92400e',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                        }}>
                            {(() => {
                                const ps = appointmentDetail.paymentStatus?.toUpperCase();
                                if (ps === 'APPROVED' || ps === 'AUTH' || ps === 'SALE' || appointmentDetail.status === 'Confirmed') return 'ÖDENDİ / ONAYLI';
                                if (ps === 'DECLINED') return 'REDDEDİLDİ';
                                if (ps === 'PENDING') return 'BEKLİYOR';
                                return 'ÖDENMEDİ';
                            })()}
                        </span>
                    </div>
                </div>
            )}
            {appointmentDetail.createdDate && (
                <div style={{ marginTop: '16px', textAlign: 'center', fontSize: '0.75rem', color: '#94a3b8' }}>
                    Oluşturulma: {new Date(appointmentDetail.createdDate).toLocaleString('tr-TR')}
                </div>
            )}
        </div>
    );
};
export default PremiumAppointmentDetailView;
